import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el producto?',
    a: '👉 Lo recibís inmediatamente luego del pago por mail.'
  }, {
    q: '¿Necesito conocimientos especiales?',
    a: '👉 No. Todo está explicado paso a paso.'
  }, {
    q: '¿Puedo imprimirlo las veces que quiera?',
    a: '👉 Sí. El material es reutilizable.'
  }, {
    q: '¿Funciona si tengo poco tiempo?',
    a: '👉 Sí. Justamente fue pensado para familias ocupadas.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: '👉 No. La mayoría de las actividades usan cosas simples del hogar.'
  }, {
    q: '¿Para qué edad es adecuado?',
    a: '👉 Principalmente para niños de 0 a 5 años.'
  }, {
    q: '¿Puedo usarlo desde el celular?',
    a: '👉 Sí. Funciona en celular, tablet y computadora.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 px-4 sm:px-6" data-id="element-103">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-104">
        <div className="text-center space-y-4" data-id="element-105">
          <span className="text-5xl block mb-4" data-id="element-106">❓</span>
          <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase text-brand-black" data-id="element-107">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-108">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-109">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-110">
                <span className="font-bold text-lg text-brand-black" data-id="element-111">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-gray-500 transition-transform ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-112" />
              </button>
              <AnimatePresence data-id="element-113">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden bg-white" data-id="element-114">
                    <div className="p-5 text-gray-700 font-medium text-lg border-t border-gray-100" data-id="element-115">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}